import React from "react";

const S: React.CSSProperties = { borderRadius: 6 };

export function SkeletonRow({ cols = 3 }: { cols?: number }) {
  return (
    <div style={{
      background: "white", border: "1px solid #e2e8f0", borderRadius: 10,
      padding: "14px 18px", display: "flex", alignItems: "center", gap: 16,
    }}>
      <div className="skeleton" style={{ width: 36, height: 36, borderRadius: 18, flexShrink: 0 }} />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 7 }}>
        <div className="skeleton" style={{ ...S, width: "40%", height: 14 }} />
        <div className="skeleton" style={{ ...S, width: "25%", height: 12 }} />
      </div>
      {Array.from({ length: Math.max(0, cols - 1) }).map((_, i) => (
        <div key={i} className="skeleton" style={{ ...S, width: 60, height: 14 }} />
      ))}
    </div>
  );
}

export function SkeletonCard() {
  return (
    <div style={{
      background: "white", border: "1px solid #e2e8f0", borderRadius: 10,
      padding: "18px 20px", display: "flex", flexDirection: "column", gap: 10,
    }}>
      <div className="skeleton" style={{ ...S, width: "60%", height: 15 }} />
      <div className="skeleton" style={{ ...S, width: "40%", height: 12 }} />
      <div className="skeleton" style={{ ...S, width: "80%", height: 12 }} />
    </div>
  );
}

export function SkeletonTable({ rows = 5, cols = 4 }: { rows?: number; cols?: number }) {
  const colW = `${Math.floor(100 / cols)}%`;
  return (
    <div style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
      <div style={{ padding: "12px 16px", borderBottom: "1px solid #f1f5f9", display: "flex", gap: 16 }}>
        {Array.from({ length: cols }).map((_, i) => (
          <div key={i} className="skeleton" style={{ ...S, width: colW, height: 12 }} />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} style={{ padding: "12px 16px", borderBottom: i < rows - 1 ? "1px solid #f8fafc" : undefined, display: "flex", gap: 16 }}>
          {Array.from({ length: cols }).map((_, j) => (
            <div key={j} className="skeleton" style={{ ...S, width: colW, height: 13 }} />
          ))}
        </div>
      ))}
    </div>
  );
}
